(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["batch-waitlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('batch-waitlist')) {
    class BatchWaitlist extends HTMLElement {
      connectedCallback() {
        this._form = this.querySelector('form');
        this._onSubmit = () => {
          document.dispatchEvent(new CustomEvent('analytics:generate_lead', {
            detail: { source: 'batch_waitlist', item_name: this.dataset.productTitle }
          }));
        };
        this._form?.addEventListener('submit', this._onSubmit);
        this._onAltClick = (event) => {
          const alt = event.target.closest('.batch-waitlist__alt');
          if (!alt) return;
          document.dispatchEvent(new CustomEvent('analytics:select_item', {
            detail: { item_id: Number(alt.dataset.productId), item_name: alt.dataset.productTitle, item_list_name: 'sold_out_alternatives' }
          }));
        };
        this.addEventListener('click', this._onAltClick);

        // Post-submit reload only (?customer_posted=true): bring the confirmation
        // into view. Never scrolls on a normal landing — a load-time scroll would
        // stop Chromium's LCP tracking (see the scroll-snap NO_LCP incident).
        if (new URLSearchParams(location.search).has('customer_posted') && this.querySelector('.batch-waitlist__success')) {
          this.scrollIntoView({ block: 'center' });
        }
      }
      disconnectedCallback() {
        this._form?.removeEventListener('submit', this._onSubmit);
        this.removeEventListener('click', this._onAltClick);
      }
    }
    customElements.define('batch-waitlist', BatchWaitlist);
  }
  } catch(e) { console.error(e); }
})();

})();
